/** The one cookie reader (AIT-426): api.ts and the optimization WebSocket used their own copies. */
export function getCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(';').shift() ?? null;
  return null;
}

/** Session token for the WebSocket query string, under any of the names the backend used. */
export function getSessionCookie(): string | null {
  return getCookie('session') || getCookie('auth') || getCookie('token');
}
